module.exports = __webpack_public_path__ + "img/profile.5a71e3ae.jpg";